import React from "react";

import ProductViewManage from "../../../Components/GMS/Products/ProductViewManage";

function ProductView(props) {
  const { params } = props.match;
  return (
    <React.Fragment>
      {/* <ProductsContextProvider> */}
      <ProductViewManage productid={params.id} />
      {/* </ProductsContextProvider> */}
    </React.Fragment>
  );
}

export default ProductView;
